import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthorizationService} from '../modules/shared/service/authorization.service';
import { environment } from '../../environments/environment';

@Injectable()
export class LoggedInGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthorizationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isUserLoggedIn()) {
      window.location.href = environment.accountSiteUrl + 'login?redirectUrl=' + window.location.href;
      return false;
    } else {
      return true;
    }
  }
}
